import { AppNavBar } from "./components/app-nav-bar"
import { Grid, View } from "@aws-amplify/ui-react"
import { Link } from "react-router-dom"
import { Outlet } from "react-router-dom"

export const PublicLayout = () => {
    return (
        <div>
            <Grid
                templateColumns="1fr"
                templateRows="4rem 1fr 2rem"
                style={{
                    height: "100%"
                }}
            >
                <View style={{ height: "4rem" }}>
                    <AppNavBar />
                </View>
                <View style={{ height: 'calc(100vh - 6rem)', overflow: 'auto' }}>
                    <Outlet />
                </View>
                <View style={{ height: "2rem" }}>
                    <div className='footer d-flex justify-content-around bg-body-tertiary'>
                        <Link to="/privacy-policy" >Privacy Policy</Link>
                        <Link to="/tutorial">Tutorial</Link>
                    </div>
                </View>
            </Grid>
        </div>)
}